<div class="text-container">
  <ng-container *ngIf="rw">
    <p>
      <!-- <mat-form-field class="text-area"> -->
      <textarea
        matInput
        [(ngModel)]="texte"
        class="text-area"
        class="text-area-content"
        type="text"
        style="height: 575px !important ; width: 100%; resize: none"></textarea>
      <!-- </mat-form-field> -->
      <!-- <textarea matInput placeholder="Saisissez une description" [(ngModel)]="texte" class="text-area"></textarea> -->
    </p>
  </ng-container>
  <ng-container *ngIf="!rw">
    <p>{{ texte }}</p>
  </ng-container>
</div>

<div class="bottom-button-container">
  <button mat-raised-button *ngIf="rw" style="margin-right: 10px" (click)="close(true)">Valider</button>
  <button mat-raised-button (click)="close(false)">Fermer</button>
</div>
